import { isParticipantLayoutActiveForGlobalMedia } from "./participant-layout-active-utils";

export function emitLegacyPasteDropMediaEvent(scene, { url, files } = {}) {
  if (isParticipantLayoutActiveForGlobalMedia()) {
    return;
  }

  if (url) {
    scene.emit("add_media", { src: url });
    return;
  }

  if (files && files.length > 0) {
    scene.emit("open_file_upload_with_files", { files: Array.from(files) });
  }
}
